"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsMessagesSent {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsMessagesSent.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsMessagesSent.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsMessagesSent.attributeTypeMap = [
    {
        "name": "campaignId",
        "baseName": "campaignId",
        "type": "number"
    },
    {
        "name": "eventTime",
        "baseName": "eventTime",
        "type": "string"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsMessagesSent = GetExtendedContactDetailsAllOfStatisticsMessagesSent;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsMessagesSent.js.map